import { render } from "./InviteUser.vue?vue&type=template&id=704b1338&scoped=true&ts=true"
import script from "./InviteUser.vue?vue&type=script&lang=ts"
export * from "./InviteUser.vue?vue&type=script&lang=ts"

import "./InviteUser.vue?vue&type=style&index=0&id=704b1338&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/webapp/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-704b1338"]])

export default __exports__